import { z } from 'zod'

export const ApplicationWorkflowFormEntitySchema = z.object({
  title: z.string(),
  steps: z.array(
    z.object({
      // NOTE:
      //  定義することでform上で変更可能となってしまうが、
      //  リクエストを送信する際にnumberとapprovers・dueDateとの紐付けが必要でこのスキーマ上にないと扱いづらいため定義する
      //  id or numberのどちらかで良いはず、APIと連携
      id: z.number(),
      number: z.number(),

      approvers: z.array(
        z.object({
          userId: z.number().nullable(),
        })
      ),
      dueDate: z.date().nullable(),
    })
  ),
  notification: z.string().optional(),
  comment: z.string().optional(),
})

export type ApplicationWorkflowFormEntity = z.infer<typeof ApplicationWorkflowFormEntitySchema>
